<template>
  <el-row :gutter="20">
    <el-col :span="16" :offset="4">
      <el-form ref="form" label-width="0px">
        <el-row>
          <div class="label-contract">
            {{ $t('promotion') }}:
          </div>
          <el-form-item>
            <el-select
              v-model="selectedPromotionId"
              :placeholder="$t('pleaseSelectPromotion')"
              style="width: 100%"
              @change="onPromotionDataChange">
              <el-option
                v-for="(promotion, index) in promotionListDataSource"
                :key="index"
                :label="bindPromotionLabel(promotion)"
                :value="promotion.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <div v-if="selectedPromotionId !== ''">
          <div class="contract-data-version" style="margin: 0 0 20px 0" v-if="isUpdatedPromotion()">
            <div class="contract-data-updated">
              <div style="padding: 20px 0 0 20px">
                <strong>*{{$t('updatedPromotionMessage')}}</strong>
              </div>
              <el-radio-group style="padding-left: 40px" v-model="promotionDataVersion" fill="#ff0000" @change="onPromotionDataChange">
                <div class="contract-data-version-radio">
                  <el-radio v-model="promotionDataVersion" :label="DATA_VERSION.SELECTED">{{$t('selectedVersion')}} ({{bindUpdatedAt(tmpSelectedPromotion.updatedAt)}})</el-radio>
                </div>
                <div class="contract-data-version-radio">
                  <el-radio v-model="promotionDataVersion" :label="DATA_VERSION.LATEST">{{$t('latestVersion')}} ({{bindLatestUpdatedAt(tmpSelectedPromotionId)}})</el-radio>
                </div>
              </el-radio-group>
            </div>
          </div>
          <div class="contract-data-version" style="margin: 0 0 20px 0" v-if="isDeletedPromotion()">
            <div class="contract-data-deleted">
              <div style="padding: 20px 0 0 20px">
                <strong style="color: #dd3333">*{{$t('deletedPromotionMessage')}}</strong>
              </div>
              <el-radio-group style="padding-left: 40px" v-model="selectedPromotionId" fill="#ff0000" >
                <el-radio :label="selectedPromotionId" class="contract-data-version-radio">{{$t('selectedVersion')}} ({{bindUpdatedAt(tmpSelectedPromotion.updatedAt)}})</el-radio>
              </el-radio-group>
            </div>
          </div>
          <el-row>
            <div v-loading="isSearching">
              <table class="table-promotion-detail" border="0" cellspacing="0" cellpadding="0">
                <tr class="table-promotion-header">
                  <td width="40%">{{$t('detail')}}</td>
                  <td width="40%">{{$t('periodOfStay')}}</td>
                  <td width="20%">{{$t('night')}}</td>
                </tr>
                <tr class="table-promotion-body">
                  <td>
                    <span v-if="selectedPromotion.detail !== ''">{{ selectedPromotion.detail }}</span>
                    <span v-if="selectedPromotion.detail === ''">-</span>
                  </td>
                  <td align="center">
                    <span v-if="selectedPromotion.periodOfStayList.length === 0">-</span>
                    <div v-for="(periodOfStay, index) of selectedPromotion.periodOfStayList" :key="`period-${index}`">
                      <span> {{bindPeriodOfStay(periodOfStay.startDate, periodOfStay.endDate)}}</span>
                    </div>
                  </td>
                  <td align="center">
                    <div>{{$t('min')}}: {{ selectedPromotion.minNight }}</div>
                    <div>{{$t('max')}}: {{ selectedPromotion.maxNight }}</div>
                  </td>
                </tr>
              </table>
            </div>
          </el-row>
          <el-row>
            <div class="label-contract">
              {{ $t('bookingPeriod') }}:
            </div>
            <el-form-item>
              <el-date-picker v-model="bookingPeriod"
                              type="daterange"
                              format="d MMMM yyyy"
                              value-format="yyyy-MM-dd"
                              start-placeholder="From"
                              end-placeholder="To"
                              style="width: 100%;"
                              @change="onPromotionDataChange">
              </el-date-picker>
            </el-form-item>
          </el-row>
          <el-row>
            <div v-loading="isSearching">
              <promotion-apply-room-type-component
                :selected-promotion-id="selectedPromotionId"
                :special-offer-promotion-selected="tmpSelectedPromotion"
                :room-type-list="roomTypeList"
                :promotion-list="promotionList"
                @onApplyRoomTypeChange="onApplyRoomTypeChange">
              </promotion-apply-room-type-component>
            </div>
          </el-row>
          <el-row>
            <div class="label-contract">
              {{ $t('remark') }}:
            </div>
            <el-form-item>
              <editor-component v-model="promotionRemark"></editor-component>
            </el-form-item>
          </el-row>
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import i18nMessages from '@/translations/SpecialOffer/components/TabSpecialOfferPromotionComponent.i18n'
import EditorComponent from '@/components/EditorComponent'
import PromotionApplyRoomTypeComponent from './PromotionComponents/PromotionApplyRoomTypeComponent'
import { getISODateFormat } from '@/helpers'
import { get, cloneDeep } from 'lodash'
import { dateFormat } from '@/helpers/datetime'
import { isUpdatedData, isDeletedData, DATA_VERSION } from '@/services/version-service'

export default {
  name: 'TabPromotionComponent',
  i18n: { messages: i18nMessages },
  components: {
    EditorComponent,
    PromotionApplyRoomTypeComponent
  },
  model: {
    prop: 'specialOfferDetail',
    event: 'onPromotionDataChange'
  },
  props: {
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    promotionList: {
      type: Array,
      default: () => {
        return []
      }
    },
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    promotionRemark: {
      get () {
        const promotionRemark = get(this.specialOfferDetail, 'promotion.remark', '')
        return promotionRemark
      },
      set (newVal) {
        this.newPromotionRemark = newVal
        this.onPromotionDataChange()
      }
    }
  },
  watch: {
    selectedPromotionId: function () {
      this.isSearching = true
      setTimeout(() => {
        this.isSearching = false
      }, 300)
    }
  },
  data () {
    return {
      DATA_VERSION,
      promotionDataVersion: DATA_VERSION.SELECTED,
      selectedPromotionId: '', // TODO: <------------------------ change datatype later after migration to fix vue runtime warn (worng data type)
      selectedPromotion: {},
      tmpSelectedPromotionId: '',
      tmpSelectedPromotion: {},
      bookingPeriod: [],
      isEnableAllotment: false,
      isShowDisableRoomType: false,
      newPromotionRemark: '',
      promotionListDataSource: [],
      applyRoomTypeList: [],
      isSearching: false
    }
  },
  created: function () {
    this.promotionListDataSource = this._getPromotionListDataSource()

    this.tmpSelectedPromotion = cloneDeep(this.selectedPromotion)
    this.tmpSelectedPromotionId = get(this.tmpSelectedPromotion, 'id', '')
    this.applyRoomTypeList = get(this.tmpSelectedPromotion, 'roomTypeList', [])
    this.isEnableAllotment = get(this.tmpSelectedPromotion, 'isEnableAllotment', false)

    const bookingPeriodStart = get(this.selectedPromotion, 'bookingPeriod.startDate', '')
    const bookingPeriodEnd = get(this.selectedPromotion, 'bookingPeriod.endDate', '')
    const startDate = getISODateFormat(new Date(bookingPeriodStart))
    const endDate = getISODateFormat(new Date(bookingPeriodEnd))

    this.bookingPeriod.push(startDate, endDate)
  },
  methods: {
    _getPromotionListDataSource: function () {
      const promotionList = cloneDeep(this.promotionList)

      this.selectedPromotion = get(this.specialOfferDetail, 'promotion', {})
      this.selectedPromotionId = get(this.selectedPromotion, 'id', '')
      this.newPromotionRemark = get(this.selectedPromotion, 'remark', '')

      if (this.selectedPromotionId === '') {
        return promotionList
      }

      const promotionSelectDataList = this._preparePromotionSelectList(promotionList)
      const promotion = promotionSelectDataList.find(item => item.id === this.selectedPromotion.id)
      if (promotion === undefined) {
        promotionSelectDataList.push(this.selectedPromotion)
      }

      return promotionSelectDataList
    },
    _preparePromotionSelectList: function (promotionList) {
      const result = promotionList.map((sourceData) => {
        if (this.selectedPromotion.id === sourceData.id) {
          const promotionUpdatedAt = get(this.selectedPromotion, 'updatedAt', 0)

          if (promotionUpdatedAt === 0) {
            this.selectedPromotion = Object.assign({}, this.selectedPromotion, sourceData)
          }

          return this.selectedPromotion
        }

        return sourceData
      })

      return result
    },
    onPromotionDataChange: function () {
      this.selectedPromotion = this.promotionListDataSource.find(promotion => promotion.id === this.selectedPromotionId)

      const selectedPromotion = this._getPromotionResult()
      const startDateIndex = 0
      const endDateIndex = 1
      const periodStart = _getPeriodDate(this.bookingPeriod, startDateIndex)
      const periodEnd = _getPeriodDate(this.bookingPeriod, endDateIndex)

      const promotionData = {
        bookingPeriod: {
          startDate: periodStart,
          endDate: periodEnd
        },
        remark: this.newPromotionRemark,
        roomTypeList: this.applyRoomTypeList,
        isEnableAllotment: this.isEnableAllotment
      }

      const promotionResult = Object.assign(selectedPromotion, promotionData)
      const promotion = {
        promotion: promotionResult
      }

      const newSpecialOfferDetail = Object.assign({}, this.specialOfferDetail, promotion)
      this.$emit('onPromotionDataChange', newSpecialOfferDetail)
    },
    bindPeriodOfStay: function (startDate, endDate) {
      const fromDate = new Date(startDate)
      const toDate = new Date(endDate)

      return `${dateFormat.short(fromDate)} - ${dateFormat.short(toDate)}`
    },
    bindPromotionLabel: function (promotion) {
      const code = get(promotion, 'code', '')
      const detail = get(promotion, 'detail', '')
      let label = `${code}`

      if (detail !== '') {
        label += ` - ${detail}`
      }

      return label
    },
    bindLatestUpdatedAt: function (promotionId) {
      const promotion = this.promotionList.find(item => item.id === promotionId)

      if (promotion !== undefined) {
        const date = new Date(promotion.updatedAt)
        return dateFormat.long(date)
      }
    },
    bindUpdatedAt: function (updatedDate) {
      if (updatedDate === undefined) {
        return '-'
      }

      const date = new Date(updatedDate)
      return dateFormat.long(date)
    },
    isUpdatedPromotion: function () {
      if (this.selectedPromotionId === '') {
        return false
      }

      if (this.tmpSelectedPromotionId !== this.selectedPromotionId) {
        return false
      }

      const isUpdated = isUpdatedData(this.promotionList, this.tmpSelectedPromotion)
      return isUpdated
    },
    isDeletedPromotion: function () {
      if (this.selectedPromotionId === '') {
        return false
      }

      if (this.tmpSelectedPromotionId !== this.selectedPromotionId) {
        return false
      }

      const isDeleted = isDeletedData(this.promotionList, this.tmpSelectedPromotionId)
      return isDeleted
    },
    onApplyRoomTypeChange: function (data) {
      this.applyRoomTypeList = data.applyRoomTypeList.filter(item => item.isEnable !== 0)
      this.isEnableAllotment = data.isEnableAllotment
      this.onPromotionDataChange()
    },
    _getPromotionResult: function () {
      if (this.promotionDataVersion === DATA_VERSION.SELECTED) {
        return this.selectedPromotion
      }

      const latestPromotion = this.promotionList.find(item => item.id === this.selectedPromotionId)
      return latestPromotion
    }
  }
}

function _getPeriodDate (specialOfferValidPeriod, periodIndex) {
  const validPeriod = get(specialOfferValidPeriod, `${periodIndex}`, 'NaN-NaN-NaN')
  const periodDate = new Date(validPeriod)

  return (isNaN(periodDate)) ? '' : validPeriod
}
</script>

<style scoped>
  .label-contract {
    font-weight: bold;
    margin: 10px 0;
  }

  .table-promotion-detail {
    width: 100%;
    margin-bottom: 22px;
  }

  .table-promotion-header td {
    text-align: center;
    padding: 10px;
    border-bottom: 1px #ddd solid;
    color: #2476e4;
    background-color: #eeeeee;
    font-size: 14px;
    font-weight: 500;
  }

  .table-promotion-body td {
    padding: 10px;
    border-bottom: 1px #ddd solid;
    font-size: 14px;
  }

  .table-apply-room-type {
    width: 100%;
    margin-bottom: 22px;
  }

  .table-apply-room-type-header td {
    padding: 10px;
    border-bottom: 1px #ddd solid;
    color: #2476e4;
    background-color: #eeeeee;
    font-size: 14px;
    font-weight: 500;
  }

  .table-apply-room-type-body td {
    padding: 10px;
    border-bottom: 1px #ddd solid;
    font-size: 14px;
  }

  .cutoff-date.el-input__inner {
    text-align: right;
    padding: 0px !important;
  }

  .allotment.el-input__inner {
    text-align: right;
    padding: 0px !important;
  }

  .input-disabled {
    background-color: #eeeeee !important;
  }

  .el-select-dropdown__item {
    max-width: 49vw;
    overflow-y: hidden;
  }
</style>
